<script setup>
import { ref, computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useCompetitionToProjectInfo } from "@/stores/competitionToProjectInfo"
import axios from "axios"

import SaveInfo from "../Base/SaveInfo.vue"
import CompleteProjectForm from "./CompleteProjectForm.vue"
import CompleteProjectForm106 from "./CompleteProjectForm106.vue"
import CompleteProjectForm128 from "./CompleteProjectForm128.vue"
import CompetitionSelectComponent from "@/components/Components/CompetitionSelectComponent.vue"

const isLoading = ref(false)
const isSubmitted = ref(false)
const isDataUpdating = ref(false)
const competitions = ref([])
const totalCompetitions = ref(0)
const isShow = ref(false)
const competitionMode = ref(false)
const questionMode = ref(false)
const citiestoinput = ref([])
const errors = ref([])
const selectedCompetitionId = ref('')

const store = useCompetitionToProjectInfo();

const totalPages = computed(() => Math.ceil(totalCompetitions.value / 10))
const currentProjectId = computed(() => window.projectId)
const windowCompetitionId = computed(() => window.competitionId || '')

const competitionToProjectInfoStore = useCompetitionToProjectInfo()
const { selectedCompetition } = storeToRefs(competitionToProjectInfoStore)

// Methods
const showModal = () => {
  if (window.new?.length > 0) {
    //checkErrors()
  }
  isShow.value = true
  competitionMode.value = true
}

const showModalQuestion = () => {
  isShow.value = true
  questionMode.value = true
}

const loadCompetition = async (id) => {
  const response = await axios.get(`/competition/apiGetCompetition/${id}/${window.projectId}`, {
    headers: { 'Accept': 'application/ld+json' }
  })
  competitions.value = [response.data]
}

async function setSelectedCompetition(id) {
  isLoading.value = true;
  let response;
  if (store.selectedCompetition?.is_bussiness_area) {
    response = await axios.get('/competition/apiGetCompetition/' + id + '/' + window.currentUserId);
  } else {
    response = await axios.get('/competition/apiGetCompetition/' + id + '/' + window.projectId);
  }

  store.selectedCompetition = response?.data;
  isLoading.value = false;
}

const loadCompetitions = async (pageNum) => {
  let url = `/competition/apiGetCompetitions/${window.projectId}/${pageNum}`
  if (pageNum === 0) {
    url = `/competition/apiGetCompetitions/${window.projectId}`
  }
  const response = await axios.get(url, {
    headers: { 'Accept': 'application/ld+json' }
  })
  competitions.value = response.data['competitions']
  totalCompetitions.value = response.data['total']
}

// Lifecycle hooks
onMounted(() => {
  if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
    alert("Эта страница может работать некорректно в браузере Safari. Рекомендуемые браузеры Яндекс.Браузер или Google Chrome.")
  }
})

if (window.competitionId?.length > 0) {
  setSelectedCompetition(window.competitionId);
  selectedCompetitionId.value = window.competitionId
}

// Не включено, так как не было определено в оригинальном коде
// const checkErrors = () => {
//   // Реализация метода checkErrors
// }
</script>

<template>
  <div>
    <SaveInfo
        :isDataUpdating="isDataUpdating"
    ></SaveInfo>
    <div v-if="!isLoading">
      <div class="content_block_top_label">
        <p v-if="selectedCompetition?.name">Текущий выбранный конкурс: <strong>{{ selectedCompetition.name }}</strong>
        </p>
	      <div class="create_request" v-if="selectedCompetition?.id !== 128">
          <p v-if="selectedCompetition?.name" style="margin: 30px 0;"><a class="button2" style=" border: 2px solid #F69F22;"
                                                                         @click.prevent="showModal">Подать заявку на
            конкурс</a></p>
          <p v-else style="margin: 30px 0;">
	          <a class="button2" @click.prevent="showModal">Перейти к отправке на конкурсы</a></p>
          <p style="margin-bottom: 30px">Чтобы подать проект на конкурс пройдите в раздел нужного вам конкурса и нажмите
            "Подать заявку"</p>
	      </div>
      </div>

      <template v-if="selectedCompetition?.id === 106">
        <CompleteProjectForm106
            :is-data-updating="isDataUpdating"
            :is-submitted="isSubmitted"
            :selectedCompetition="selectedCompetition"
            @loadCompetition="(val) => { loadCompetition(val)}"
            @loadCompetitions="(val) => { loadCompetitions(val)}"
            @onErrorsChange="(val)=>{this.errors = val;}"
        ></CompleteProjectForm106>
      </template>
      <template v-if="selectedCompetition?.id === 128">
        <CompleteProjectForm128
            :is-data-updating="isDataUpdating"
            :is-submitted="isSubmitted"
            :selectedCompetition="selectedCompetition"
            @loadCompetition="(val) => { loadCompetition(val)}"
            @setSelectedCompetition="(val) => { setSelectedCompetition(val)}"
            @loadCompetitions="(val) => { loadCompetitions(val)}"
            @onErrorsChange="(val)=>{this.errors = val;}"
            @onDataUpdating="(val)=>{isDataUpdating = val;}"
        ></CompleteProjectForm128>
      </template>
      <template v-else>
        <CompleteProjectForm
            :is-data-updating="isDataUpdating"
            :is-submitted="isSubmitted"
            :selectedCompetition="selectedCompetition"
            @loadCompetition="(val) => { loadCompetition(val)}"
            @loadCompetitions="(val) => { loadCompetitions(val)}"
            @onErrorsChange="(val)=>{this.errors = val;}"
        ></CompleteProjectForm>
      </template>
    </div>
    <div v-else style="text-align: center">
      <div class="lds-default">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>

    <a-modal
        v-model:visible="isShow"
        :footer="null"
        width="70%"
        :destroyOnClose="true"
        :style="{ 'max-width': '1000px' }"
    >
      <CompetitionSelectComponent
          :competition-mode="competitionMode"
          :question-mode="questionMode"
          :competitions="competitions"
          :totalCompetitions="totalCompetitions"
          :is-loading="isLoading"
          @loadCompetitions="loadCompetitions"
          @close="isShow = false"
          :errors="errors"
      />
    </a-modal>
  </div>
</template>



<style scoped>
.field_description {
    font-size: 13px;
}

/*.modal {*/
/*  display: block;*/
/*  width: 80%;*/
/*  max-width: 950px;*/
/*  padding: 30px;*/
/*  box-sizing: border-box;*/
/*  background-color: #fff;*/
/*  font-size: 20px;*/
/*  text-align: center;*/
/*  margin: 30px auto 30px;*/
/*  position: relative;*/
/*}*/

.category_select_active {
    font-weight: bold;
}

.close_button {
    position: absolute;
    right: 15px;
    top: 10px;
    font-size: 20px;
    cursor: pointer;
}

.vue-universal-modal {
    z-index: 111;
}

.errors-block {
    color: red;
    border: 1px solid #999;
    border-radius: 10px;
    padding: 25px;
    margin-bottom: 30px;
}

.lds-default {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
    transform: scale(0.5);
    text-align: center;
}

.lds-default div {
    position: absolute;
    width: 6px;
    height: 6px;
    background: #000;
    border-radius: 50%;
    animation: lds-default 1.2s linear infinite;
}

.lds-default div:nth-child(1) {
    animation-delay: 0s;
    top: 37px;
    left: 66px;
}

.lds-default div:nth-child(2) {
    animation-delay: -0.1s;
    top: 22px;
    left: 62px;
}

.lds-default div:nth-child(3) {
    animation-delay: -0.2s;
    top: 11px;
    left: 52px;
}

.lds-default div:nth-child(4) {
    animation-delay: -0.3s;
    top: 7px;
    left: 37px;
}

.lds-default div:nth-child(5) {
    animation-delay: -0.4s;
    top: 11px;
    left: 22px;
}

.lds-default div:nth-child(6) {
    animation-delay: -0.5s;
    top: 22px;
    left: 11px;
}

.lds-default div:nth-child(7) {
    animation-delay: -0.6s;
    top: 37px;
    left: 7px;
}

.lds-default div:nth-child(8) {
    animation-delay: -0.7s;
    top: 52px;
    left: 11px;
}

.lds-default div:nth-child(9) {
    animation-delay: -0.8s;
    top: 62px;
    left: 22px;
}

.lds-default div:nth-child(10) {
    animation-delay: -0.9s;
    top: 66px;
    left: 37px;
}

.lds-default div:nth-child(11) {
    animation-delay: -1s;
    top: 62px;
    left: 52px;
}

.lds-default div:nth-child(12) {
    animation-delay: -1.1s;
    top: 52px;
    left: 62px;
}

.competition_wrapper {
    position: relative;
    max-width: 355px;
}

.modal .columns.is-multiline {
    justify-content: center;
}

.modal .columns.is-multiline .col1 {
    margin-right: 50px;
    margin-bottom: 70px;
}


.competition-info {
    background: #FEF4E5;
    padding: 20px;
}

.competition-image-wrapper {
    position: relative;
    display: flex;
    border-bottom: 5px solid #F69F22;
}

.choise_category h1 {
    font-size: 21px;
}

.vue-universal-modal {
    z-index: 111;
}

.competition-title__wrapper {
    line-height: 1;
}

.competition-title {
    font-size: 16px;
}

.category_select {
    font-size: 18px;
}

.content_block .tabs ul {
    align-items: inherit;
}

.content_block .tabs ul li {
    display: flex;
}

.category_select:hover {
    color: #F69F22;
    cursor: pointer;
}

.competition_wrapper_inner:hover .competiton_order_button_div {
    display: block;
}

.help_text {
    margin-bottom: 30px;
    margin-top: 30px;
    font-style: italic;
    color: #8F9194;
    cursor: pointer;
}

.help_text svg {
    margin-right: 10px;
}

.modal_question {
    text-align: left;
    font-size: 16px;
}

@keyframes lds-default {
    0%, 20%, 80%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.5);
    }
}

</style>
